(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var ZOOM_LEVEL = 2.2;
  var LARGE_WIDTH = '2048';

  function largeSrc(img) {
    var src = img.currentSrc || img.getAttribute('src');
    if (!src) return null;
    try {
      var url = new URL(src, window.location.href);
      url.searchParams.set('width', LARGE_WIDTH);
      return url.toString();
    } catch (e) {
      return src;
    }
  }

  function setupZoom(mediaEl) {
    if (mediaEl.dataset.hzInit === 'true') return;
    mediaEl.dataset.hzInit = 'true';

    var img = mediaEl.querySelector('img');
    if (!img) return;

    mediaEl.classList.add('hz-zoom-target');

    var lens = document.createElement('div');
    lens.className = 'hz-zoom-lens';
    lens.setAttribute('aria-hidden', 'true');
    mediaEl.insertBefore(lens, mediaEl.firstChild);

    var rect = null;
    var pendingEvent = null;
    var rafId = null;

    function applyMove() {
      rafId = null;
      if (!pendingEvent) return;
      var e = pendingEvent;
      pendingEvent = null;
      if (!rect) rect = mediaEl.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) return;
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      x = Math.max(0, Math.min(100, x));
      y = Math.max(0, Math.min(100, y));
      lens.style.backgroundPosition = x + '% ' + y + '%';
    }

    function onEnter() {
      var src = largeSrc(img);
      if (!src) return;
      lens.style.backgroundImage = 'url("' + src + '")';
      lens.style.backgroundSize = (ZOOM_LEVEL * 100) + '%';
      rect = mediaEl.getBoundingClientRect();
      lens.classList.add('is-active');
    }

    function onMove(e) {
      // Batch mousemove handling to once per animation frame so we never do
      // more than one style write per paint, keeping the main thread free
      // for click/tap interactions (helps INP).
      pendingEvent = e;
      if (rafId == null) {
        rafId = window.requestAnimationFrame(applyMove);
      }
    }

    function onLeave() {
      lens.classList.remove('is-active');
      rect = null;
      pendingEvent = null;
      if (rafId != null) {
        window.cancelAnimationFrame(rafId);
        rafId = null;
      }
    }

    mediaEl.addEventListener('mouseenter', onEnter, { passive: true });
    mediaEl.addEventListener('mousemove', onMove, { passive: true });
    mediaEl.addEventListener('mouseleave', onLeave, { passive: true });
  }

  function init() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document
      .querySelectorAll(
        'media-gallery slideshow-component .product-media-container--zoomable .product-media'
      )
      .forEach(setupZoom);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
